import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6caf82f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hr-mail-form" }
const _hoisted_2 = {
  key: 0,
  class: "hr-mail-error",
  role: "alert"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { value: "RU" }
const _hoisted_7 = { value: "EN" }
const _hoisted_8 = {
  key: 1,
  class: "hr-mail-types"
}
const _hoisted_9 = { class: "hr-mail-select-actions" }
const _hoisted_10 = ["value", "disabled"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "hr-mail-error"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 3,
  open: ""
}

import {
  computed,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import { Button } from "@/components/common";
import Modal from "@/components/common/Modal.vue";
import HrDataService from "@/services/hr/HrDataService";
import {
  HrDocumentType,
  HrNotificationPreview,
  HrNotificationRequest,
} from "@/types/hr/Hr";
import { t } from "@/i18n";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { storedAccountKey } from "@/utils/accountSession";


export default /*#__PURE__*/_defineComponent({
  props: {
    show: null,
    employeeIds: null,
    mode: null,
    eligibleTypeIds: null
  },
  emits: ["close", "sent"],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean;
  employeeIds: string[];
  mode: "REQUEST" | "EXPIRY";
  eligibleTypeIds?: string[];
}

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */


const types = ref<HrDocumentType[]>([]);
const selectedTypes = ref<string[]>([]);
const language = ref<"RU" | "EN">("RU");
const previews = ref<HrNotificationPreview[] | null>(null);
const loading = ref(false);
const loaded = ref(false);
const busy = ref(false);
const error = ref("");
let requestId = "";
let generation = 0;
let openedAccountKey: string | null = null;
const previewPage = ref(1);
const previewPages = computed(() =>
  Math.ceil((previews.value?.length || 0) / 25)
);
const visiblePreviews = computed(
  () =>
    previews.value?.slice(
      (previewPage.value - 1) * 25,
      previewPage.value * 25
    ) || []
);
const completedEmployeeIds = new Set<string>();

function currentOperation(current: number, signature: string) {
  return (
    current === generation &&
    props.show &&
    openedAccountKey === storedAccountKey() &&
    signature === JSON.stringify(payload())
  );
}
const title = computed(() =>
  props.mode === "EXPIRY"
    ? t("hr.enableExpiry")
    : t("hr.requestMissingDocuments")
);
const recipientCount = computed(
  () =>
    (previews.value || []).filter(
      (item) =>
        !item.problemCode && (props.mode === "EXPIRY" || item.documents.length)
    ).length
);
const hasProblems = computed(() =>
  (previews.value || []).some((item) => Boolean(item.problemCode))
);
const expiryEnabled = computed(() => props.mode === "EXPIRY");

function newRequestId() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) =>
    value.toString(16).padStart(2, "0")
  ).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function payload(): HrNotificationRequest {
  return {
    language: language.value,
    requestId,
    employeeIds: [...props.employeeIds],
    documentTypeIds: props.mode === "EXPIRY" ? [] : [...selectedTypes.value],
    completePreparation: false,
    enableExpiryNotifications: expiryEnabled.value,
  };
}

watch(
  () => props.show,
  async (show) => {
    const current = ++generation;
    if (!show) return;
    openedAccountKey = storedAccountKey();
    busy.value = false;
    completedEmployeeIds.clear();
    error.value = "";
    previews.value = null;
    loaded.value = false;
    loading.value = true;
    requestId = newRequestId();
    language.value = "RU";
    try {
      const response = await HrDataService.getDocumentTypes();
      if (current !== generation) return;
      types.value = (response.data.data as HrDocumentType[]).filter(item => props.eligibleTypeIds === undefined || props.eligibleTypeIds.includes(item.id));
      selectedTypes.value = [];
      loaded.value = true;
    } catch (exception: unknown) {
      if (current === generation) error.value = apiError(exception);
    } finally {
      if (current === generation) loading.value = false;
    }
  },
  { immediate: true }
);

watch(
  [
    selectedTypes,
    language,
    () => props.employeeIds.join(","),
    () => props.mode,
  ],
  () => {
    previews.value = null;
    previewPage.value = 1;
    completedEmployeeIds.clear();
    if (!busy.value) requestId = newRequestId();
  },
  { deep: true }
);

async function preview() {
  if (
    busy.value ||
    !loaded.value ||
    !props.show ||
    !props.employeeIds.length ||
    (props.mode === "REQUEST" && !selectedTypes.value.length)
  )
    return;
  if (openedAccountKey !== storedAccountKey()) return;
  const current = generation;
  const request = payload();
  const signature = JSON.stringify(request);
  busy.value = true;
  error.value = "";
  previews.value = null;
  try {
    const items: HrNotificationPreview[] = [];
    for (let start = 0; start < request.employeeIds.length; start += 150) {
      if (!currentOperation(current, signature)) return;
      const response = await HrDataService.previewNotifications({
        ...request,
        employeeIds: request.employeeIds.slice(start, start + 150),
      });
      if (!currentOperation(current, signature)) return;
      items.push(...response.data.data);
    }
    previews.value = items;
    previewPage.value = 1;
  } catch (exception: unknown) {
    if (currentOperation(current, signature)) error.value = apiError(exception);
  } finally {
    if (current === generation) busy.value = false;
  }
}

async function confirm() {
  if (
    busy.value ||
    !props.show ||
    !props.employeeIds.length ||
    !previews.value ||
    hasProblems.value ||
    (props.mode === "REQUEST" && !recipientCount.value)
  )
    return;
  if (openedAccountKey !== storedAccountKey()) return;
  const current = generation;
  const request = payload();
  const signature = JSON.stringify(request);
  busy.value = true;
  error.value = "";
  try {
    const remaining = request.employeeIds.filter(
      (id) => !completedEmployeeIds.has(id)
    );
    for (let start = 0; start < remaining.length; start += 150) {
      if (!currentOperation(current, signature)) return;
      const ids = remaining.slice(start, start + 150);
      if (props.mode === "EXPIRY")
        await HrDataService.setExpiryNotifications(ids, true);
      else
        await HrDataService.sendNotifications({ ...request, employeeIds: ids });
      if (!currentOperation(current, signature)) return;
      ids.forEach((id) => completedEmployeeIds.add(id));
    }
    emit("sent");
    emit("close");
  } catch (exception: unknown) {
    if (currentOperation(current, signature)) {
      error.value =
        (completedEmployeeIds.size
          ? t("hr.bulkPartial").replace(
              "{count}",
              String(completedEmployeeIds.size)
            ) + " "
          : "") + apiError(exception);
    }
  } finally {
    if (current === generation) busy.value = false;
  }
}

function close() {
  if (!busy.value) emit("close");
}
onBeforeUnmount(() => {
  generation++;
});
function apiError(exception: unknown) {
  const response = exception as { response?: { data?: { message?: string } } };
  return response.response?.data?.message || t("hr.mailActionError");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    title: _unref(title),
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.mailPrivacyHint")), 1),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("hr.loading")), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (__props.mode === 'REQUEST')
                ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_unref(t)("hr.notificationLanguage")) + " ", 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
                      class: "input-form",
                      disabled: busy.value
                    }, [
                      _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(t)("hr.russianLanguage")), 1),
                      _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(t)("hr.englishLanguage")), 1)
                    ], 8, _hoisted_5), [
                      [_vModelSelect, language.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.mode !== 'EXPIRY')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(Button), {
                        type: "button",
                        variant: "default",
                        disabled: busy.value || !types.value.length,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedTypes.value = types.value.map((item) => item.id)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("hr.selectAll")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(Button), {
                        type: "button",
                        variant: "default",
                        disabled: busy.value || !selectedTypes.value.length,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedTypes.value = []))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("hr.deselectAll")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: item.id
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedTypes).value = $event)),
                          type: "checkbox",
                          value: item.id,
                          disabled: busy.value
                        }, null, 8, _hoisted_10), [
                          [_vModelCheckbox, selectedTypes.value]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item.name) + " — " + _toDisplayString(item.required ? _unref(t)("hr.required") : _unref(t)("hr.optional")), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(expiryEnabled))
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(t)("hr.expiryScheduleHint")), 1))
                : _createCommentVNode("", true),
              _createVNode(_unref(Button), {
                type: "button",
                disabled: 
            busy.value || !loaded.value || (__props.mode === 'REQUEST' && !selectedTypes.value.length)
          ,
                onClick: preview
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(busy.value ? _unref(t)("hr.loading") : _unref(t)("hr.previewMail")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              (previews.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.mailRecipientCount")) + ": " + _toDisplayString(_unref(recipientCount)) + " / " + _toDisplayString(__props.employeeIds.length), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visiblePreviews), (item) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: item.employeeId,
                        class: "hr-mail-preview"
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(item.fullName), 1),
                        _createElementVNode("span", null, _toDisplayString(item.recipient || _unref(t)("hr.emailMissing")), 1),
                        (item.problemCode)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(t)(`hr.mailProblem.${item.problemCode}`)), 1))
                          : _createCommentVNode("", true),
                        (_unref(expiryEnabled))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.expiredDocuments")) + ": " + _toDisplayString(item.expiredDocumentCount) + "; " + _toDisplayString(_unref(t)("hr.upcomingDocuments")) + ": " + _toDisplayString(item.upcomingDocumentCount), 1),
                              (item.missingExpiryCount)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)("hr.missingExpiryDates")) + ": " + _toDisplayString(item.missingExpiryCount), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (__props.mode !== 'EXPIRY' && !item.documents.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)("hr.noDocumentsToRequest")), 1))
                          : (__props.mode !== 'EXPIRY')
                            ? (_openBlock(), _createElementBlock("details", _hoisted_15, [
                                _createElementVNode("summary", null, _toDisplayString(language.value === "EN"
                      ? _unref(t)("hr.englishLanguage")
                      : _unref(t)("hr.russianLanguage")), 1),
                                _createElementVNode("pre", null, _toDisplayString(language.value === 'EN' ? item.bodyEn : item.bodyRu), 1)
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createVNode(TablePagination, {
                      current: previewPage.value,
                      "total-pages": _unref(previewPages),
                      "start-page": Math.max(1, previewPage.value - 2),
                      "end-page": Math.min(_unref(previewPages), previewPage.value + 2),
                      onPageChanged: _cache[4] || (_cache[4] = ($event: any) => (previewPage.value = $event))
                    }, null, 8, ["current", "total-pages", "start-page", "end-page"]),
                    _createVNode(_unref(Button), {
                      type: "button",
                      disabled: 
              busy.value || _unref(hasProblems) || (__props.mode === 'REQUEST' && !_unref(recipientCount))
            ,
                      onClick: confirm
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(busy.value
                ? _unref(t)("hr.saving")
                : __props.mode === "EXPIRY"
                ? _unref(t)("hr.enableExpiry")
                : _unref(t)("hr.confirmSend")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})